export default __webpack_public_path__ + "static/media/PrizeCupBronze.d4cc0f71.png";